<template>
    <header v-if="!hasNoHeader">
        <largeNav v-if="width > 992"></largeNav>
        <smallNav v-else></smallNav>
    </header>

    <RouterView v-slot="{ Component, route }">
        <transition :name="['SurveyConsent', 'Survey', 'terms'].includes(currentRouteName) ? 'fade' : ''" mode="out-in">
            <div :key="route.name">
                <component :is="Component"></component>
            </div>
        </transition>
    </RouterView>

	<InactivityModal v-if="isLoggedIn && timeToLogout" :timeLeft="timeToLogout" @closeModal="reloadPage"></InactivityModal>
	<Toast></Toast>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import largeNav from './components/nav/large.vue';
import smallNav from './components/nav/small.vue';
import { useAuthStore } from "@/stores/auth-store";
import apiClient from "@/utils/axios";
import { useHttpErrorManager } from '@/composables/useHttpErrorManager';
import Toast from "@/components/Toast.vue";
import InactivityModal from "@/components/GenericModalAndViews/InactivityModal.vue";
import { waitForWebsocketConnection } from '@/utils/echo';

const authStore = useAuthStore();
const { width } = useWindowSize();
const router = useRouter();
const route = useRoute()
const currentRouteName = computed(() => route.name)
const hasNoHeader = computed(() => route.meta && route.meta.noHeader);

const core_cookies = ref(false);
const third_party_cookies = ref(false);
const cookies = ref(localStorage.getItem("cookies_status"));
const isLoggedIn = ref(authStore.isLoggedIn);

const routeError = ref(false);

const timeToLogout = ref(null);
watch(() => authStore.isLoggedIn, async () => {

    isLoggedIn.value = authStore.isLoggedIn;
	if (isLoggedIn.value) {

		while(authStore.isUpdatingCSRF){
			await new Promise(r => setTimeout(r, 500));
		}

		Echo.private('session.destroyed.' + authStore.user.session_id)
		.listen('.SessionDestroyed', async (e) => {
			await authStore.processLogout();
		});

		// Echo.private('user.' + authStore.user.id)
		// .listen('.TrustedDeviceRemoved', async (e) => {
		// });

		// Echo.channel('user.logged_in')
		// .listen('.UserLoggedIn', async (e) => {
		// });

		Echo.private('user.inactive.' + authStore.user.session_id)
		.listen('InactiveUser', async (e) => {
			if(e.timeLeft <= 0) {
				await authStore.processLogout();
				return;
			}
			timeToLogout.value = e.timeLeft * 60;
		});
	}
});

const cookies_accepted = computed(() => {
    return cookies.value === 1;
});

const reloadPage = () => {
	timeToLogout.value = null;
    router.push({ path: route.path });
};

onMounted(async () => {
	await waitForWebsocketConnection();
    screen.orientation.addEventListener("change", reloadPage);
});

router.afterEach((to) => {
    routeError.value = to.name === 'error';
});

const accept_cookies = () => {
    localStorage.setItem("cookies_status", 1);
    localStorage.setItem("core_cookies", 1);
    if (third_party_cookies.value) {
        localStorage.setItem("third_party_cookies", 1);
    } else {
        localStorage.setItem("third_party_cookies", 0);
    }
    cookies.value = 1;

    if (isLoggedIn.value) {
        update_db_cookies_status();
    }
}

const update_db_cookies_status = async () => {
    let third = localStorage.getItem("third_party_cookies");
    if (third === undefined || third == null) {
        third = 0;
    }
    let url = "/auth/user/cookies/accept";
    let data = {
        core: 1,
        third: third,
    };
    await apiClient
        .post(url, data)
        .then(async (response) => { })
        .catch((error) => { });
}

const check_db_cookie_status = async () => {
    if (!cookies_accepted.value && isLoggedIn.value) {
        let url = "/auth/user/cookies/status";
        let data = {};
        await apiClient
            .get(url, data)
            .then(async (response) => {
                if (response.data.result === 1) {
                    core_cookies.value = true;
                    third_party_cookies.value = response.data.third === 1;
                    accept_cookies();
                } else {
                    cookies.value = 0;
                }
            })
            .catch(async (error) => {
                let errorObj = await useHttpErrorManager().handleError(error, false);
            });
    }
}

</script>